import React from "react";
import { useIntl } from "react-intl";
import { Reader } from "../graphql";

const formatInfo = (str: string | undefined) => {
  if (str === undefined) {
    return "";
  }
  let a = str.length / 2 + 1;
  let b = a / 2;
  let newstr = str.substring(0, b);
  newstr += "*".repeat(a);
  newstr += str.substring(b + a);
  return newstr;
};

type UserInfoProps = {
  reader?: Reader;
};

export default function UserInfo({ reader }: UserInfoProps) {
  const { formatMessage } = useIntl();

  return (
    <div className="userinfo">
      {reader !== undefined && (
        <p>
          {formatMessage({ id: "hyvendor.column.readercode" })}:
          <span>{formatInfo(reader.reader_code)}</span>
        </p>
      )}
      {reader !== undefined && (
        <p>
          {formatMessage({ id: "hyvendor.column.readername" })}:
          <span>{formatInfo(reader.reader_name)}</span>
        </p>
      )}
    </div>
  );
}
